import { render, staticRenderFns } from "./_qv-tabs.vue?vue&type=template&id=3a49679c&scoped=true"
import script from "./_qv-tabs.vue?vue&type=script&lang=js"
export * from "./_qv-tabs.vue?vue&type=script&lang=js"
import style0 from "./_qv-tabs.vue?vue&type=style&index=0&id=3a49679c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a49679c",
  null
  
)

export default component.exports